import React from 'react';
import Modal from 'Views/Components/Modal/Modal';
import { Button, Colors, Display } from 'Views/Components/Button/Button';

interface IInfoModalProps {
	isOpen: boolean,
	title: string,
	description: string,
	onCloseModal: () => void
}

const InfoModal = (props: IInfoModalProps) => {
	const {
		isOpen,
		title,
		description,
		onCloseModal,
	} = props;

	return (
		<Modal
			className="information-modal"
			label="Info modal"
			isOpen={isOpen}
			onRequestClose={onCloseModal}
		>
			<div className="modal__header">
				<h4>{title}</h4>
			</div>
			<div className="modal__message">
				<p>{description}</p>
			</div>
			<div className="modal__actions">
				<Button
					key="cancel"
					onClick={onCloseModal}
					type="button"
					colors={Colors.Primary}
					display={Display.Outline}
				>
					Close
				</Button>
			</div>
		</Modal>
	);
};

export default InfoModal;
